<template>
  <div class="bh-user-card--wrap">
    <div class="bh-user-card">
      <profile-preview-image
        :key="bhUser.profileId + '-' + bhUser.id"
        :profileId="bhUser.profileId"
        :avatarSize="80"
        :avatarClasses="['bh-user-card__avatar--wrap', 'avatar', 'rounded']"
        :imageClasses="['bh-user-card__avatar']"
        :thumbnailUrl="bhUser.thumbnailUrl"
      />
      <div class="bh-user-card__name--wrap">
        <p class="bh-user-card__name" v-if="bhUser.firstName||bhUser.lastName"><span>{{ bhUser.firstName}}</span> <span>{{bhUser.lastName.length > 10 ? bhUser.lastName.substring(0,1) + "." : bhUser.lastName}}</span></p>
        <span class="bh-user-card__status">
          <i class="bh-dot bhYellowDark">&nbsp;</i> {{ bhUser.isActive ? 'Active' : 'Inactive'}}
        </span>
      </div>
    </div>
    <span class="bh-user-card__last-login bhGray3--text" v-if="bhUser.lastLoginDate">
      Last login: <span class="bhBlack--text">{{$moment(bhUser.lastLoginDate).format("MMM DD, YYYY hh:mm A")}}</span>
    </span>
    <span class="bh-user-card__last-activity bhGray3--text" v-if="bhUser.lastActivity">
      Last activity: <span class="bhBlack--text">{{$moment(bhUser.lastActivity).format("MMM DD, YYYY hh:mm A")}}</span>
    </span>
  </div>
</template>

<script>
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue';
export default {
  components: { ProfilePreviewImage },
  name: "BhUserCard",
  props: {
    bhUser: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables";

.bh-user-card {
  display: flex;

  &__avatar {
    border-radius: $border-radius-root2;

    &--wrap {
      display: flex;
      position: relative;
      margin-right: 16px;
      flex-shrink: 0;
      width: 80px;
      height: 80px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }

  &__name {
    font-size: 1.42857rem;
    line-height: 1;
    color: $bh-blue;
    font-weight: 700;
    span {
      display: block;
    }
    &--wrap {
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      height: 100%;
    }
  }

  &__status {
    font-size: 0.85715rem;
    line-height: 1.16666667em;

    .bh-dot {
      margin-right: 8px;
    }
  }

  &__last-login {
    display: inline-block;
    width: 100%;
    font-size: 0.85715rem;
    line-height: 1.16666667em;
    padding: 20px 0 0;
  }
  &__last-activity {
    display: inline-block;
    width: 100%;
    font-size: 0.85715rem;
    line-height: 1.16666667em;
    padding: 5px 0 0;
  }
}
</style>
